import React from 'react';
import LegalDocumentPage from './LegalDocumentPage';

export default function SecurityPage() {
  return (
    <LegalDocumentPage
      slug="security"
      fallbackTitle="Безопасность платежей"
      fallbackFile="/docs/security.html"
    />
  );
}